import { render, staticRenderFns } from "./LimitNull.vue?vue&type=template&id=3993d156&scoped=true&"
import script from "./LimitNull.vue?vue&type=script&lang=ts&"
export * from "./LimitNull.vue?vue&type=script&lang=ts&"
import style0 from "./LimitNull.vue?vue&type=style&index=0&id=3993d156&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993d156",
  null
  
)

export default component.exports